import EvaluatorPaymentsBaseTab from "./EvaluatorPaymentsBaseTab";

export default class PendingApprovalTab extends EvaluatorPaymentsBaseTab {
    getType() {
        return "pending_approval";
    }
}